/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FiMenu } from 'react-icons/fi';

function SidebarLayout({ MenuComponent }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar for desktop */}
      <div className="hidden md:block w-64">
        <MenuComponent />
      </div>

      {/* Mobile Hamburger */}
      <div className="md:hidden absolute top-4 left-4 z-50">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="p-2 bg-gray-800 text-white rounded-md focus:outline-none"
        >
          <FiMenu size={22} />
        </button>
      </div>

      {/* Mobile Sidebar (Drawer) */}
      {isOpen && (
        <div className="fixed inset-0 z-40 flex">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black opacity-50"
            onClick={() => setIsOpen(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                setIsOpen(false);
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Close modal"
          />

          {/* Slide-in Menu */}
          <div className="relative bg-gray-800 w-64 min-h-screen p-4">
            <MenuComponent closeMenu={() => setIsOpen(false)} />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 p-6">
        <Outlet />
      </div>
    </div>
  );
}

export default SidebarLayout;

// Validate props
SidebarLayout.propTypes = {
  MenuComponent: PropTypes.elementType,
};

// Default props to satisfy react/require-default-props
SidebarLayout.defaultProps = {
  MenuComponent: () => {},
};
